var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard9Clubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000153694093722011237880000010644360127270045860_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.6,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9,292.5c0,17.8,4.9,35.7,6.6,41.3c0.3,0.9-0.4,1.8-1.4,1.8h-53.6c-1,0-1.7-0.9-1.4-1.8c1.7-5.7,6.6-23.7,6.6-41.3 c-7.1,5.1-15.3,7.8-24.4,7.8c-26.3,0-49.1-22.1-47.4-48.7c0.9-15,10.4-27.8,23.1-35.8s24.6-8.6,35.1-6.1 c-6.8-8-10.8-18.3-10.8-29.6c0-28.4,25.7-50.7,55.1-45c18.4,3.6,33,18.7,36.1,37.1c2.4,14.3-1.9,27.7-10.2,37.5 c10.6-2.6,22.5-1.9,35.4,6.2c12.6,8,22.1,20.8,23,35.8c1.5,26.5-21.3,48.5-47.5,48.5C190.3,300.3,181.8,297.6,174.9,292.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8,132.5c15.8,0,28.7-12.9,28.7-28.7V60.7c0-4-3.2-7.2-7.2-7.2s-7.2,3.2-7.2,7.2v43.1c0,7.9-6.5,14.4-14.4,14.4 c-6.1,0-11.5-3.9-13.5-9.6c-1.3-3.7-5.4-5.7-9.2-4.3c-3.7,1.3-5.7,5.4-4.3,9.2C34.8,124.8,45.6,132.5,57.8,132.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8,31.9c-15.9,0-28.7,12.9-28.7,28.7S42,89.3,57.8,89.3s28.7-12.9,28.7-28.7S73.7,31.9,57.8,31.9z M57.8,75.1 c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4s14.4,6.4,14.4,14.4S65.7,75.1,57.8,75.1z"
  })), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.4,370.4c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S289.4,350,289.4,370.4z  M252.6,339.9c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S269.4,339.9,252.6,339.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.3,363.6c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C271.6,351.4,277.3,357,277.3,363.6z M272.2,363.6c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C268.7,371.1,272.2,367.8,272.2,363.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.6,386.6c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C258.5,380.3,261.6,383.1,261.6,386.6z  M257.4,386.6c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C256.2,389.2,257.4,388.1,257.4,386.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,359.8c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C247.7,361,246.3,359.8,244.7,359.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,379.7c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S236.4,379.7,234.8,379.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M270.6,383.4c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C273.5,384.7,272.2,383.4,270.6,383.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 252.6,
    cy: 370.4,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029048020517273781240000018424351476797493123_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029048020517273781240000018424351476797493123_)"
    },
    d: "M242,350.6c-0.2,3.5-3.4,6.2-7.2,6 c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C239.3,344.1,242.2,347.2,242,350.6z M237.7,350.4c0.1-1.4-1-2.6-2.5-2.7 c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C236.4,352.9,237.7,351.8,237.7,350.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard9Clubs);
export default __webpack_public_path__ + "static/media/card_9-clubs.0811b8c64a5d971e91ee6d50f5de32d5.svg";
export { ForwardRef as ReactComponent };